module.exports = __webpack_public_path__ + "fonts/sourcesanspro-light-webfont.c3ac3017.woff2";